import FoodType from "./filters/FoodType"
import FilterResults from "./FilterResults"
import foodFilterTypes from "./filters/filterTypes/foodFilterTypes"
import beverageFilterTypes from "./filters/filterTypes/beverageFilterTypes"

const fetchFoodFilter = (filter, setFilterFn) => {
  return foodFilterTypes(filter)({ setFilterFn })
}

const fetchBeverageFilter = (filter, setFilterFn) => {
  return beverageFilterTypes(filter)({ setFilterFn })
}

const Filter = ({ filter, filterClassification, setFilterFn, transporters }) => {
  const filterClassifications = {
    beverage: [fetchBeverageFilter, [filter, setFilterFn]],
    food: [fetchFoodFilter, [filter, setFilterFn]],
    foodType: [FoodType, [{ setFilterFn }]],
    results: [FilterResults, [{ transporters, setFilterFn }]],
  }
  const fn = filterClassifications[filterClassification]
  return fn[0](...fn[1])
}

export default Filter
